var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgSpace20 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.59138 19.8616C8.44587 19.8616 8.30284 19.8222 8.17623 19.7474L1.01833 15.5178C0.754475 15.3619 0.591385 15.07 0.591385 14.7536V5.96945C0.591385 5.6531 0.754475 5.36119 1.01833 5.20523L8.17623 0.975655C8.43381 0.823606 8.74896 0.823606 9.00654 0.975655L16.1644 5.20523C16.4283 5.36119 16.5914 5.6531 16.5914 5.96945V14.7536C16.5914 15.07 16.4283 15.3619 16.1644 15.5178L9.00654 19.7474C8.87992 19.8222 8.7369 19.8616 8.59138 19.8616ZM2.2756 14.2415L8.59138 17.973L14.9072 14.2415V6.48157L8.59138 2.75006L2.2756 6.48069V14.2415Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.2756 14.2415L8.59139 17.973L14.9072 14.2415V6.48158L8.59139 2.75006L2.2756 6.4807V14.2415Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgSpace20);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/space-20.fafc9ba7ff0492d520896e57e9a3823e.svg";